import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "setting",
  "use": "setting-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"setting\"><path d=\"M14 8V6l-1.72-.86c-.07-.19-.15-.37-.23-.55l.61-1.83-1.42-1.42L9.41 2l-.55-.23L8 0H6l-.86 1.72-.55.28-1.83-.66-1.42 1.42L2 4.59c-.08.18-.16.36-.23.55L0 6v2l1.72.86c.07.19.15.37.23.55l-.61 1.83 1.42 1.42 1.83-.61.55.23L6 14h2l.86-1.72.55-.23 1.83.61 1.42-1.42-.61-1.83c.08-.18.16-.36.23-.55zM7 9.8A2.8 2.8 0 119.8 7 2.81 2.81 0 017 9.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id